import { render, staticRenderFns } from "./NavCard.vue?vue&type=template&id=19745f96&"
import script from "./NavCard.vue?vue&type=script&lang=js&"
export * from "./NavCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19745f96')) {
      api.createRecord('19745f96', component.options)
    } else {
      api.reload('19745f96', component.options)
    }
    module.hot.accept("./NavCard.vue?vue&type=template&id=19745f96&", function () {
      api.rerender('19745f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/nav-card/NavCard.vue"
export default component.exports